import { InjectionToken } from '@angular/core';
import { ErrorBaseContents } from '../base-contents/base-contents.model';

export interface TridionDownConfig {
    contents: ErrorBaseContents;
}

export const tridionDownConfigToken = new InjectionToken<TridionDownConfig>('tridionDownConfigToken');
